import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { systemPropertyOwnershipStatus } = loanFormModel.formField;

class IsOwned implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const isOwned = application[systemPropertyOwnershipStatus.name] === 'OWNED';

    return isOwned;
  }
}

export default new IsOwned();
